// extracted by mini-css-extract-plugin
module.exports = {"confetti":"confetti-module--confetti--180yh","fadeOut":"confetti-module--fadeOut--1r9PO"};